import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

import { Select2Data } from "../../../utils/common";

export const AllPermmission = createAsyncThunk(
  "common/masters/all-permission",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllPermmission);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllRoles = createAsyncThunk(
  "common/masters/all-role",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllRoles}?name=${filter}`);
      console.log(res, "res res rrrrrrrrrrrrrrrrrrrr");

      return await Select2Data(res.data, "role_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Country - Get All
export const AllCountry = createAsyncThunk(
  "common/masters/all-country",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllCountry}?name=${filter}`);

      return await Select2Data(res.data.data, "country_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// State - Get All (for a specific country)
export const AllState = createAsyncThunk(
  "common/masters/all-state/:id",
  async ({ countryId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllState}/${countryId}?name=${name}`,
      );

      // You can adjust Select2Data if necessary
      return await Select2Data(res.data.data, "state_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// City - Get All (for a specific state)
export const AllCity = createAsyncThunk(
  "common/masters/all-city/:id",
  async ({ stateId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllCity}/${stateId}?name=${name}`);
      return await Select2Data(res.data.data, "city_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Pincode - Get All (for a specific city)
export const AllPincode = createAsyncThunk(
  "common/masters/all-pincode/:id",
  async ({ cityId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllPincode}/${cityId}?name=${name}`,
      );
      return await Select2Data(res.data.data, "pincode_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllSocialLink = createAsyncThunk(
  "common/masters/all-property-type",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllSocialLink}?name=${filter}`);

      return await Select2Data(res.data.data, "social_link_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllHelpCategory = createAsyncThunk(
  "common/masters/all-help-category",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllHelpCategory}?name=${filter}`);

      return await Select2Data(res.data.data, "help_category_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// export const AllGalleryCAtegory = createAsyncThunk(
//   "common/masters/all-gallery-category",
//   async (filter = "", { rejectWithValue }) => {
//     try {
//       const res = await GET(
//         `${APIS.Commons.AllGalleryCAtegory}?name=${filter}`
//       );

//       return await Select2Data(res.data.data, "gallery_category_id");
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

export const AllGalleryCategory = createAsyncThunk(
  "common/masters/all-gallery-category",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllGalleryCategory}?name=${filter}`,
      );
      return await Select2Data(res.data.data, "gallery_category_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllCategory = createAsyncThunk(
  "common/masters/all-category",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllCategory}?name=${filter}`);
      return await Select2Data(res.data.data, "category_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Country - Get All
export const AppSetup = createAsyncThunk(
  "common/masters/appsetup",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AppSetup}?name=${filter}`);
      return res.data;
      // return await Select2Data(res.data, "volunteer_detail_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllUniversity = createAsyncThunk(
  "common/masters/all-university",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllUniversity}?name=${filter}`);

      return await Select2Data(res.data.data, "university_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allCourse = createAsyncThunk(
  "common/masters/all-course/:id",
  async ({ universityId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.allCourse}/${universityId}?name=${name}`,
      );

      // You can adjust Select2Data if necessary
      return await Select2Data(res.data.data, "course_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allProgramHighlight = createAsyncThunk(
  "common/masters/all-program-highlight",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.allProgramHighlight}?name=${filter}`,
      );

      return await Select2Data(res.data.data, "program_highlight_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allEligibilityReqirement = createAsyncThunk(
  "common/masters/all-eligibility-requirement",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.allEligibilityReqirement}?name=${filter}`,
      );

      return await Select2Data(res.data.data, "eligibility_requirement_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allCareerRequirement = createAsyncThunk(
  "common/masters/all-career-requirement",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.allCareerRequirement}?name=${filter}`,
      );

      return await Select2Data(res.data.data, "career_requirement_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allRequiredDocument = createAsyncThunk(
  "common/masters/all-required-documents",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.allRequiredDocument}?name=${filter}`,
      );

      return await Select2Data(res.data.data, "requirement_document_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allAccomodation = createAsyncThunk(
  "common/masters/all-accomodation",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.allAccomodation}?name=${filter}`);

      return await Select2Data(res.data.data, "accomodation_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allDocument = createAsyncThunk(
  "common/masters/all-document",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.allDocument}?name=${filter}`);

      return await Select2Data(res.data.data, "document_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allRequirement = createAsyncThunk(
  "common/masters/all-requirement",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.allRequirement}?name=${filter}`);

      return await Select2Data(res.data.data, "requirement_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allAcceptRejectStatus = createAsyncThunk(
  "common/masters/all-acceptrejectstatus",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.allAcceptRejectStatus}?name=${filter}`,
      );

      return await Select2Data(res.data.data, "accept_reject_status_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allFaq = createAsyncThunk(
  "common/masters/all-faq",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.allFaq);

      return res?.data?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allTicketStatus = createAsyncThunk(
  "common/masters/all-ticket_statuses",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.allTicketStatus}?name=${filter}`);

      return await Select2Data(res.data.data, "ticket_status_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allStudentDocument = createAsyncThunk(
  "common/masters/all-student-document",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.all_student_document}?name=${filter}`,
      );

      return await Select2Data(res.data.data, "student_document_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllGender = createAsyncThunk(
  "common/masters/all-gender",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllGender}?name=${filter}`);

      return await Select2Data(res.data.data, "gender_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllCollegeType = createAsyncThunk(
  "common/masters/all-college-type",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllCollegeType}?name=${filter}`);

      return await Select2Data(res.data.data, "college_type_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "common",
  initialState: {
    all_country: [],
    all_state: [],
    all_city: [],
    all_pincode: [],
    all_social_links: [],
    all_help_category: [],
    all_gallery_category: [],
    all_category: [],
    all_appsetup: [],
    all_permission: [],
    all_university: [],
    all_course: [],
    all_program_highlight: [],
    all_eligibility_requirement: [],
    all_career_requirement: [],
    all_requirement_document: [],
    all_accomodation: [],
    all_document: [],
    all_requirement: [],
    all_accept_reject_status: [],
    all_faq: [],
    all_ticket_status: [],
    all_student_document: [],
    all_gender: [],
    all_college_type: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete
      .addCase(AllCountry.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCountry.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_country = action.payload || [];
      })
      .addCase(AllCountry.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling AllState actions
      .addCase(AllState.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllState.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_state = action.payload || [];
      })
      .addCase(AllState.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllCity.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCity.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_city = action.payload || [];
      })
      .addCase(AllCity.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling AllPincode actions
      .addCase(AllPincode.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPincode.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_pincode = action.payload || [];
      })
      .addCase(AllPincode.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllSocialLink.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllSocialLink.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_social_links = action.payload || [];
      })
      .addCase(AllSocialLink.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllHelpCategory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllHelpCategory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_help_category = action.payload || [];
      })
      .addCase(AllHelpCategory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // .addCase(AllGalleryCAtegory.pending, (state) => {
      //   state.status = IDS.SLICESTATUS.Loading;
      // })
      // .addCase(AllGalleryCAtegory.fulfilled, (state, action) => {
      //   state.status = IDS.SLICESTATUS.Succeeded;
      //   state.all_gallery_category = action.payload || [];
      // })
      // .addCase(AllGalleryCAtegory.rejected, (state, action) => {
      //   state.status = IDS.SLICESTATUS.Failed;
      //   state.error = action.payload;
      // })

      .addCase(AllGalleryCategory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllGalleryCategory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_gallery_category = action.payload || [];
      })
      .addCase(AllGalleryCategory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllCategory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCategory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_category = action.payload || [];
      })
      .addCase(AllCategory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AppSetup.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AppSetup.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_appsetup = action.payload || [];
      })
      .addCase(AppSetup.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllPermmission.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPermmission.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;

        state.all_permission = action.payload || {};
      })
      .addCase(AllPermmission.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;

        state.error = action.payload;
      })

      .addCase(AllUniversity.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllUniversity.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_university = action.payload || [];
      })
      .addCase(AllUniversity.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(allCourse.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(allCourse.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_course = action.payload || [];
      })
      .addCase(allCourse.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(allProgramHighlight.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(allProgramHighlight.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_program_highlight = action.payload || [];
      })
      .addCase(allProgramHighlight.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(allEligibilityReqirement.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(allEligibilityReqirement.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_eligibility_requirement = action.payload || [];
      })
      .addCase(allEligibilityReqirement.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(allCareerRequirement.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(allCareerRequirement.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_career_requirement = action.payload || [];
      })
      .addCase(allCareerRequirement.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(allRequiredDocument.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(allRequiredDocument.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_requirement_document = action.payload || [];
      })
      .addCase(allRequiredDocument.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(allAccomodation.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(allAccomodation.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_accomodation = action.payload || [];
      })
      .addCase(allAccomodation.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(allDocument.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(allDocument.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_document = action.payload || [];
      })
      .addCase(allDocument.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(allRequirement.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(allRequirement.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_requirement = action.payload || [];
      })
      .addCase(allRequirement.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(allAcceptRejectStatus.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(allAcceptRejectStatus.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_accept_reject_status = action.payload || [];
      })
      .addCase(allAcceptRejectStatus.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(allFaq.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(allFaq.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_faq = action.payload || [];
      })
      .addCase(allFaq.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(allTicketStatus.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(allTicketStatus.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_ticket_status = action.payload || [];
      })
      .addCase(allTicketStatus.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(allStudentDocument.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(allStudentDocument.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_student_document = action.payload || [];
      })
      .addCase(allStudentDocument.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllGender.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllGender.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_gender = action.payload || [];
      })
      .addCase(AllGender.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllCollegeType.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCollegeType.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_college_type = action.payload || [];
      })
      .addCase(AllCollegeType.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
